import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable no-unused-vars */
import Prompt from '../../Prompt';
import styles from './GeoGebraInteraction.scss';
import { t } from '../../../../../services/i18nService';
import sessionReader from './../../../../../store/readHelpers/SessionReader';
import DownloadButton from '../../../../buttons/DownloadButton';

class GeoGebraInteraction extends React.PureComponent {
    static propTypes = {
        model: PropTypes.object.isRequired, // model taken from responseModels related to this interaction
        handleInteractionReady: PropTypes.func.isRequired,
        userResponse: PropTypes.array.isRequired, // array containing the user answer as the only entry
    };

    componentDidMount() {
        this.props.handleInteractionReady(this.props.model.identifier);
    }

    getGgbResponseFromUserResponse = (userResponse) => {
        try {
            return userResponse[0]?.length > 0
                ? userResponse[0]
                : undefined;
        } catch (error) {
            return undefined;
        }
    };

    render() {
        const { model, userResponse } = this.props;
        let ggbBase64 = this.getGgbResponseFromUserResponse(userResponse);
        let ggbFileName = `${sessionReader.getCandidateId()}-submission-file`;

        if (!ggbBase64) {
            ggbBase64 = model.geogebraBase64;
            ggbFileName = 'author-file';
        }

        return (
            <div className="interaction">
                <Prompt model={model.prompt} />
                <div className={styles.deprecatedWrapper}>
                    <h4>{t('interactions.geogebra.notSupportedWarning')}</h4>
                    {
                        !sessionReader.isContextExam() && ggbBase64
                            ? <DownloadButton
                                fileDownloadUrl={`data:application/octet-stream;base64,${ggbBase64}`}
                                fileDownloadName={`${ggbFileName}.ggb`}
                            />
                            : null
                    }
                </div>
            </div>
        );
    }
}

export default GeoGebraInteraction;
